/*
 *
 * LanguageProvider constants
 *
 */

export const CHANGE_LOCALE = "app/LanguageToggle/CHANGE_LOCALE";
export const CHANGE = "app/LanguageToggle/CHANGE";
